/**
 * Get the base time zone (at index 0) for the probided timeZoneId array
 */
export default function getBaseTimeZone(timeZoneIds: string[]): string {
    return timeZoneIds && timeZoneIds.length > 0 ? timeZoneIds[0] : null;
}
